// AUTO-MAINTAINED by scripts/import_haydock.py.
// Add new chapter files under data/chapters/<book>/<n>.js and run:
//     python3 scripts/import_haydock.py --update-index

import _1_corinthians_1 from "./1-corinthians/1";
import _1_corinthians_2 from "./1-corinthians/2";
import _1_corinthians_3 from "./1-corinthians/3";
import _1_corinthians_4 from "./1-corinthians/4";
import _1_corinthians_5 from "./1-corinthians/5";
import _1_corinthians_6 from "./1-corinthians/6";
import _1_corinthians_7 from "./1-corinthians/7";
import _1_corinthians_8 from "./1-corinthians/8";
import _1_corinthians_9 from "./1-corinthians/9";
import _1_corinthians_10 from "./1-corinthians/10";
import _1_corinthians_11 from "./1-corinthians/11";
import _1_corinthians_12 from "./1-corinthians/12";
import _1_corinthians_13 from "./1-corinthians/13";
import _1_corinthians_14 from "./1-corinthians/14";
import _1_corinthians_15 from "./1-corinthians/15";
import _1_corinthians_16 from "./1-corinthians/16";
import _1_esdras_1 from "./1-esdras/1";
import _1_esdras_2 from "./1-esdras/2";
import _1_esdras_3 from "./1-esdras/3";
import _1_esdras_4 from "./1-esdras/4";
import _1_esdras_5 from "./1-esdras/5";
import _1_esdras_6 from "./1-esdras/6";
import _1_esdras_7 from "./1-esdras/7";
import _1_esdras_8 from "./1-esdras/8";
import _1_esdras_9 from "./1-esdras/9";
import _1_esdras_10 from "./1-esdras/10";
import _1_john_1 from "./1-john/1";
import _1_john_2 from "./1-john/2";
import _1_john_3 from "./1-john/3";
import _1_john_4 from "./1-john/4";
import _1_john_5 from "./1-john/5";
import _1_kings_1 from "./1-kings/1";
import _1_kings_2 from "./1-kings/2";
import _1_kings_3 from "./1-kings/3";
import _1_kings_4 from "./1-kings/4";
import _1_kings_5 from "./1-kings/5";
import _1_kings_6 from "./1-kings/6";
import _1_kings_7 from "./1-kings/7";
import _1_kings_8 from "./1-kings/8";
import _1_kings_9 from "./1-kings/9";
import _1_kings_10 from "./1-kings/10";
import _1_kings_11 from "./1-kings/11";
import _1_kings_12 from "./1-kings/12";
import _1_kings_13 from "./1-kings/13";
import _1_kings_14 from "./1-kings/14";
import _1_kings_15 from "./1-kings/15";
import _1_kings_16 from "./1-kings/16";
import _1_kings_17 from "./1-kings/17";
import _1_kings_18 from "./1-kings/18";
import _1_kings_19 from "./1-kings/19";
import _1_kings_20 from "./1-kings/20";
import _1_kings_21 from "./1-kings/21";
import _1_kings_22 from "./1-kings/22";
import _1_kings_23 from "./1-kings/23";
import _1_kings_24 from "./1-kings/24";
import _1_kings_25 from "./1-kings/25";
import _1_kings_26 from "./1-kings/26";
import _1_kings_27 from "./1-kings/27";
import _1_kings_28 from "./1-kings/28";
import _1_kings_29 from "./1-kings/29";
import _1_kings_30 from "./1-kings/30";
import _1_kings_31 from "./1-kings/31";
import _1_machabees_1 from "./1-machabees/1";
import _1_machabees_2 from "./1-machabees/2";
import _1_machabees_3 from "./1-machabees/3";
import _1_machabees_4 from "./1-machabees/4";
import _1_machabees_5 from "./1-machabees/5";
import _1_machabees_6 from "./1-machabees/6";
import _1_machabees_7 from "./1-machabees/7";
import _1_machabees_8 from "./1-machabees/8";
import _1_machabees_9 from "./1-machabees/9";
import _1_machabees_10 from "./1-machabees/10";
import _1_machabees_11 from "./1-machabees/11";
import _1_machabees_12 from "./1-machabees/12";
import _1_machabees_13 from "./1-machabees/13";
import _1_machabees_14 from "./1-machabees/14";
import _1_machabees_15 from "./1-machabees/15";
import _1_machabees_16 from "./1-machabees/16";
import _1_paralipomenon_1 from "./1-paralipomenon/1";
import _1_paralipomenon_2 from "./1-paralipomenon/2";
import _1_paralipomenon_3 from "./1-paralipomenon/3";
import _1_paralipomenon_4 from "./1-paralipomenon/4";
import _1_paralipomenon_5 from "./1-paralipomenon/5";
import _1_paralipomenon_6 from "./1-paralipomenon/6";
import _1_paralipomenon_7 from "./1-paralipomenon/7";
import _1_paralipomenon_8 from "./1-paralipomenon/8";
import _1_paralipomenon_9 from "./1-paralipomenon/9";
import _1_paralipomenon_10 from "./1-paralipomenon/10";
import _1_paralipomenon_11 from "./1-paralipomenon/11";
import _1_paralipomenon_12 from "./1-paralipomenon/12";
import _1_paralipomenon_13 from "./1-paralipomenon/13";
import _1_paralipomenon_14 from "./1-paralipomenon/14";
import _1_paralipomenon_15 from "./1-paralipomenon/15";
import _1_paralipomenon_16 from "./1-paralipomenon/16";
import _1_paralipomenon_17 from "./1-paralipomenon/17";
import _1_paralipomenon_18 from "./1-paralipomenon/18";
import _1_paralipomenon_19 from "./1-paralipomenon/19";
import _1_paralipomenon_20 from "./1-paralipomenon/20";
import _1_paralipomenon_21 from "./1-paralipomenon/21";
import _1_paralipomenon_22 from "./1-paralipomenon/22";
import _1_paralipomenon_23 from "./1-paralipomenon/23";
import _1_paralipomenon_24 from "./1-paralipomenon/24";
import _1_paralipomenon_25 from "./1-paralipomenon/25";
import _1_paralipomenon_26 from "./1-paralipomenon/26";
import _1_paralipomenon_27 from "./1-paralipomenon/27";
import _1_paralipomenon_28 from "./1-paralipomenon/28";
import _1_paralipomenon_29 from "./1-paralipomenon/29";
import _1_peter_1 from "./1-peter/1";
import _1_peter_2 from "./1-peter/2";
import _1_peter_3 from "./1-peter/3";
import _1_peter_4 from "./1-peter/4";
import _1_peter_5 from "./1-peter/5";
import _1_thessalonians_1 from "./1-thessalonians/1";
import _1_thessalonians_2 from "./1-thessalonians/2";
import _1_thessalonians_3 from "./1-thessalonians/3";
import _1_thessalonians_4 from "./1-thessalonians/4";
import _1_thessalonians_5 from "./1-thessalonians/5";
import _1_timothy_1 from "./1-timothy/1";
import _1_timothy_2 from "./1-timothy/2";
import _1_timothy_3 from "./1-timothy/3";
import _1_timothy_4 from "./1-timothy/4";
import _1_timothy_5 from "./1-timothy/5";
import _1_timothy_6 from "./1-timothy/6";
import _2_corinthians_1 from "./2-corinthians/1";
import _2_corinthians_2 from "./2-corinthians/2";
import _2_corinthians_3 from "./2-corinthians/3";
import _2_corinthians_4 from "./2-corinthians/4";
import _2_corinthians_5 from "./2-corinthians/5";
import _2_corinthians_6 from "./2-corinthians/6";
import _2_corinthians_7 from "./2-corinthians/7";
import _2_corinthians_8 from "./2-corinthians/8";
import _2_corinthians_9 from "./2-corinthians/9";
import _2_corinthians_10 from "./2-corinthians/10";
import _2_corinthians_11 from "./2-corinthians/11";
import _2_corinthians_12 from "./2-corinthians/12";
import _2_corinthians_13 from "./2-corinthians/13";
import _2_esdras_1 from "./2-esdras/1";
import _2_esdras_2 from "./2-esdras/2";
import _2_esdras_3 from "./2-esdras/3";
import _2_esdras_4 from "./2-esdras/4";
import _2_esdras_5 from "./2-esdras/5";
import _2_esdras_6 from "./2-esdras/6";
import _2_esdras_7 from "./2-esdras/7";
import _2_esdras_8 from "./2-esdras/8";
import _2_esdras_9 from "./2-esdras/9";
import _2_esdras_10 from "./2-esdras/10";
import _2_esdras_11 from "./2-esdras/11";
import _2_esdras_12 from "./2-esdras/12";
import _2_esdras_13 from "./2-esdras/13";
import _2_john_1 from "./2-john/1";
import _2_kings_1 from "./2-kings/1";
import _2_kings_2 from "./2-kings/2";
import _2_kings_3 from "./2-kings/3";
import _2_kings_4 from "./2-kings/4";
import _2_kings_5 from "./2-kings/5";
import _2_kings_6 from "./2-kings/6";
import _2_kings_7 from "./2-kings/7";
import _2_kings_8 from "./2-kings/8";
import _2_kings_9 from "./2-kings/9";
import _2_kings_10 from "./2-kings/10";
import _2_kings_11 from "./2-kings/11";
import _2_kings_12 from "./2-kings/12";
import _2_kings_13 from "./2-kings/13";
import _2_kings_14 from "./2-kings/14";
import _2_kings_15 from "./2-kings/15";
import _2_kings_16 from "./2-kings/16";
import _2_kings_17 from "./2-kings/17";
import _2_kings_18 from "./2-kings/18";
import _2_kings_19 from "./2-kings/19";
import _2_kings_20 from "./2-kings/20";
import _2_kings_21 from "./2-kings/21";
import _2_kings_22 from "./2-kings/22";
import _2_kings_23 from "./2-kings/23";
import _2_kings_24 from "./2-kings/24";
import _2_machabees_1 from "./2-machabees/1";
import _2_machabees_2 from "./2-machabees/2";
import _2_machabees_3 from "./2-machabees/3";
import _2_machabees_4 from "./2-machabees/4";
import _2_machabees_5 from "./2-machabees/5";
import _2_machabees_6 from "./2-machabees/6";
import _2_machabees_7 from "./2-machabees/7";
import _2_machabees_8 from "./2-machabees/8";
import _2_machabees_9 from "./2-machabees/9";
import _2_machabees_10 from "./2-machabees/10";
import _2_machabees_11 from "./2-machabees/11";
import _2_machabees_12 from "./2-machabees/12";
import _2_machabees_13 from "./2-machabees/13";
import _2_machabees_14 from "./2-machabees/14";
import _2_machabees_15 from "./2-machabees/15";
import _2_paralipomenon_1 from "./2-paralipomenon/1";
import _2_paralipomenon_2 from "./2-paralipomenon/2";
import _2_paralipomenon_3 from "./2-paralipomenon/3";
import _2_paralipomenon_4 from "./2-paralipomenon/4";
import _2_paralipomenon_5 from "./2-paralipomenon/5";
import _2_paralipomenon_6 from "./2-paralipomenon/6";
import _2_paralipomenon_7 from "./2-paralipomenon/7";
import _2_paralipomenon_8 from "./2-paralipomenon/8";
import _2_paralipomenon_9 from "./2-paralipomenon/9";
import _2_paralipomenon_10 from "./2-paralipomenon/10";
import _2_paralipomenon_11 from "./2-paralipomenon/11";
import _2_paralipomenon_12 from "./2-paralipomenon/12";
import _2_paralipomenon_13 from "./2-paralipomenon/13";
import _2_paralipomenon_14 from "./2-paralipomenon/14";
import _2_paralipomenon_15 from "./2-paralipomenon/15";
import _2_paralipomenon_16 from "./2-paralipomenon/16";
import _2_paralipomenon_17 from "./2-paralipomenon/17";
import _2_paralipomenon_18 from "./2-paralipomenon/18";
import _2_paralipomenon_19 from "./2-paralipomenon/19";
import _2_paralipomenon_20 from "./2-paralipomenon/20";
import _2_paralipomenon_21 from "./2-paralipomenon/21";
import _2_paralipomenon_22 from "./2-paralipomenon/22";
import _2_paralipomenon_23 from "./2-paralipomenon/23";
import _2_paralipomenon_24 from "./2-paralipomenon/24";
import _2_paralipomenon_25 from "./2-paralipomenon/25";
import _2_paralipomenon_26 from "./2-paralipomenon/26";
import _2_paralipomenon_27 from "./2-paralipomenon/27";
import _2_paralipomenon_28 from "./2-paralipomenon/28";
import _2_paralipomenon_29 from "./2-paralipomenon/29";
import _2_paralipomenon_30 from "./2-paralipomenon/30";
import _2_paralipomenon_31 from "./2-paralipomenon/31";
import _2_paralipomenon_32 from "./2-paralipomenon/32";
import _2_paralipomenon_33 from "./2-paralipomenon/33";
import _2_paralipomenon_34 from "./2-paralipomenon/34";
import _2_paralipomenon_35 from "./2-paralipomenon/35";
import _2_paralipomenon_36 from "./2-paralipomenon/36";
import _2_peter_1 from "./2-peter/1";
import _2_peter_2 from "./2-peter/2";
import _2_peter_3 from "./2-peter/3";
import _2_thessalonians_1 from "./2-thessalonians/1";
import _2_thessalonians_2 from "./2-thessalonians/2";
import _2_thessalonians_3 from "./2-thessalonians/3";
import _2_timothy_1 from "./2-timothy/1";
import _2_timothy_2 from "./2-timothy/2";
import _2_timothy_3 from "./2-timothy/3";
import _2_timothy_4 from "./2-timothy/4";
import _3_john_1 from "./3-john/1";
import _3_kings_1 from "./3-kings/1";
import _3_kings_2 from "./3-kings/2";
import _3_kings_3 from "./3-kings/3";
import _3_kings_4 from "./3-kings/4";
import _3_kings_5 from "./3-kings/5";
import _3_kings_6 from "./3-kings/6";
import _3_kings_7 from "./3-kings/7";
import _3_kings_8 from "./3-kings/8";
import _3_kings_9 from "./3-kings/9";
import _3_kings_10 from "./3-kings/10";
import _3_kings_11 from "./3-kings/11";
import _3_kings_12 from "./3-kings/12";
import _3_kings_13 from "./3-kings/13";
import _3_kings_14 from "./3-kings/14";
import _3_kings_15 from "./3-kings/15";
import _3_kings_16 from "./3-kings/16";
import _3_kings_17 from "./3-kings/17";
import _3_kings_18 from "./3-kings/18";
import _3_kings_19 from "./3-kings/19";
import _3_kings_20 from "./3-kings/20";
import _3_kings_21 from "./3-kings/21";
import _3_kings_22 from "./3-kings/22";
import _4_kings_1 from "./4-kings/1";
import _4_kings_2 from "./4-kings/2";
import _4_kings_3 from "./4-kings/3";
import _4_kings_4 from "./4-kings/4";
import _4_kings_5 from "./4-kings/5";
import _4_kings_6 from "./4-kings/6";
import _4_kings_7 from "./4-kings/7";
import _4_kings_8 from "./4-kings/8";
import _4_kings_9 from "./4-kings/9";
import _4_kings_10 from "./4-kings/10";
import _4_kings_11 from "./4-kings/11";
import _4_kings_12 from "./4-kings/12";
import _4_kings_13 from "./4-kings/13";
import _4_kings_14 from "./4-kings/14";
import _4_kings_15 from "./4-kings/15";
import _4_kings_16 from "./4-kings/16";
import _4_kings_17 from "./4-kings/17";
import _4_kings_18 from "./4-kings/18";
import _4_kings_19 from "./4-kings/19";
import _4_kings_20 from "./4-kings/20";
import _4_kings_21 from "./4-kings/21";
import _4_kings_22 from "./4-kings/22";
import _4_kings_23 from "./4-kings/23";
import _4_kings_24 from "./4-kings/24";
import _4_kings_25 from "./4-kings/25";
import abdias_1 from "./abdias/1";
import acts_of_the_apostles_1 from "./acts-of-the-apostles/1";
import acts_of_the_apostles_2 from "./acts-of-the-apostles/2";
import acts_of_the_apostles_3 from "./acts-of-the-apostles/3";
import acts_of_the_apostles_4 from "./acts-of-the-apostles/4";
import acts_of_the_apostles_5 from "./acts-of-the-apostles/5";
import acts_of_the_apostles_6 from "./acts-of-the-apostles/6";
import acts_of_the_apostles_7 from "./acts-of-the-apostles/7";
import acts_of_the_apostles_8 from "./acts-of-the-apostles/8";
import acts_of_the_apostles_9 from "./acts-of-the-apostles/9";
import acts_of_the_apostles_10 from "./acts-of-the-apostles/10";
import acts_of_the_apostles_11 from "./acts-of-the-apostles/11";
import acts_of_the_apostles_12 from "./acts-of-the-apostles/12";
import acts_of_the_apostles_13 from "./acts-of-the-apostles/13";
import acts_of_the_apostles_14 from "./acts-of-the-apostles/14";
import acts_of_the_apostles_15 from "./acts-of-the-apostles/15";
import acts_of_the_apostles_16 from "./acts-of-the-apostles/16";
import acts_of_the_apostles_17 from "./acts-of-the-apostles/17";
import acts_of_the_apostles_18 from "./acts-of-the-apostles/18";
import acts_of_the_apostles_19 from "./acts-of-the-apostles/19";
import acts_of_the_apostles_20 from "./acts-of-the-apostles/20";
import acts_of_the_apostles_21 from "./acts-of-the-apostles/21";
import acts_of_the_apostles_22 from "./acts-of-the-apostles/22";
import acts_of_the_apostles_23 from "./acts-of-the-apostles/23";
import acts_of_the_apostles_24 from "./acts-of-the-apostles/24";
import acts_of_the_apostles_25 from "./acts-of-the-apostles/25";
import acts_of_the_apostles_26 from "./acts-of-the-apostles/26";
import acts_of_the_apostles_27 from "./acts-of-the-apostles/27";
import acts_of_the_apostles_28 from "./acts-of-the-apostles/28";
import aggeus_1 from "./aggeus/1";
import aggeus_2 from "./aggeus/2";
import amos_1 from "./amos/1";
import amos_2 from "./amos/2";
import amos_3 from "./amos/3";
import amos_4 from "./amos/4";
import amos_5 from "./amos/5";
import amos_6 from "./amos/6";
import amos_7 from "./amos/7";
import amos_8 from "./amos/8";
import amos_9 from "./amos/9";
import apocalypse_1 from "./apocalypse/1";
import apocalypse_2 from "./apocalypse/2";
import apocalypse_3 from "./apocalypse/3";
import apocalypse_4 from "./apocalypse/4";
import apocalypse_5 from "./apocalypse/5";
import apocalypse_6 from "./apocalypse/6";
import apocalypse_7 from "./apocalypse/7";
import apocalypse_8 from "./apocalypse/8";
import apocalypse_9 from "./apocalypse/9";
import apocalypse_10 from "./apocalypse/10";
import apocalypse_11 from "./apocalypse/11";
import apocalypse_12 from "./apocalypse/12";
import apocalypse_13 from "./apocalypse/13";
import apocalypse_14 from "./apocalypse/14";
import apocalypse_15 from "./apocalypse/15";
import apocalypse_16 from "./apocalypse/16";
import apocalypse_17 from "./apocalypse/17";
import apocalypse_18 from "./apocalypse/18";
import apocalypse_19 from "./apocalypse/19";
import apocalypse_20 from "./apocalypse/20";
import apocalypse_21 from "./apocalypse/21";
import apocalypse_22 from "./apocalypse/22";
import baruch_1 from "./baruch/1";
import baruch_2 from "./baruch/2";
import baruch_3 from "./baruch/3";
import baruch_4 from "./baruch/4";
import baruch_5 from "./baruch/5";
import baruch_6 from "./baruch/6";
import canticle_of_canticles_1 from "./canticle-of-canticles/1";
import canticle_of_canticles_2 from "./canticle-of-canticles/2";
import canticle_of_canticles_3 from "./canticle-of-canticles/3";
import canticle_of_canticles_4 from "./canticle-of-canticles/4";
import canticle_of_canticles_5 from "./canticle-of-canticles/5";
import canticle_of_canticles_6 from "./canticle-of-canticles/6";
import canticle_of_canticles_7 from "./canticle-of-canticles/7";
import canticle_of_canticles_8 from "./canticle-of-canticles/8";
import colossians_1 from "./colossians/1";
import colossians_2 from "./colossians/2";
import colossians_3 from "./colossians/3";
import colossians_4 from "./colossians/4";
import daniel_1 from "./daniel/1";
import daniel_2 from "./daniel/2";
import daniel_3 from "./daniel/3";
import daniel_4 from "./daniel/4";
import daniel_5 from "./daniel/5";
import daniel_6 from "./daniel/6";
import daniel_7 from "./daniel/7";
import daniel_8 from "./daniel/8";
import daniel_9 from "./daniel/9";
import daniel_10 from "./daniel/10";
import daniel_11 from "./daniel/11";
import daniel_12 from "./daniel/12";
import daniel_13 from "./daniel/13";
import daniel_14 from "./daniel/14";
import deuteronomy_1 from "./deuteronomy/1";
import deuteronomy_2 from "./deuteronomy/2";
import deuteronomy_3 from "./deuteronomy/3";
import deuteronomy_4 from "./deuteronomy/4";
import deuteronomy_5 from "./deuteronomy/5";
import deuteronomy_6 from "./deuteronomy/6";
import deuteronomy_7 from "./deuteronomy/7";
import deuteronomy_8 from "./deuteronomy/8";
import deuteronomy_9 from "./deuteronomy/9";
import deuteronomy_10 from "./deuteronomy/10";
import deuteronomy_11 from "./deuteronomy/11";
import deuteronomy_12 from "./deuteronomy/12";
import deuteronomy_13 from "./deuteronomy/13";
import deuteronomy_14 from "./deuteronomy/14";
import deuteronomy_15 from "./deuteronomy/15";
import deuteronomy_16 from "./deuteronomy/16";
import deuteronomy_17 from "./deuteronomy/17";
import deuteronomy_18 from "./deuteronomy/18";
import deuteronomy_19 from "./deuteronomy/19";
import deuteronomy_20 from "./deuteronomy/20";
import deuteronomy_21 from "./deuteronomy/21";
import deuteronomy_22 from "./deuteronomy/22";
import deuteronomy_23 from "./deuteronomy/23";
import deuteronomy_24 from "./deuteronomy/24";
import deuteronomy_25 from "./deuteronomy/25";
import deuteronomy_26 from "./deuteronomy/26";
import deuteronomy_27 from "./deuteronomy/27";
import deuteronomy_28 from "./deuteronomy/28";
import deuteronomy_29 from "./deuteronomy/29";
import deuteronomy_30 from "./deuteronomy/30";
import deuteronomy_31 from "./deuteronomy/31";
import deuteronomy_32 from "./deuteronomy/32";
import deuteronomy_33 from "./deuteronomy/33";
import deuteronomy_34 from "./deuteronomy/34";
import ecclesiastes_1 from "./ecclesiastes/1";
import ecclesiastes_2 from "./ecclesiastes/2";
import ecclesiastes_3 from "./ecclesiastes/3";
import ecclesiastes_4 from "./ecclesiastes/4";
import ecclesiastes_5 from "./ecclesiastes/5";
import ecclesiastes_6 from "./ecclesiastes/6";
import ecclesiastes_7 from "./ecclesiastes/7";
import ecclesiastes_8 from "./ecclesiastes/8";
import ecclesiastes_9 from "./ecclesiastes/9";
import ecclesiastes_10 from "./ecclesiastes/10";
import ecclesiastes_11 from "./ecclesiastes/11";
import ecclesiastes_12 from "./ecclesiastes/12";
import ecclesiasticus_1 from "./ecclesiasticus/1";
import ecclesiasticus_2 from "./ecclesiasticus/2";
import ecclesiasticus_3 from "./ecclesiasticus/3";
import ecclesiasticus_4 from "./ecclesiasticus/4";
import ecclesiasticus_5 from "./ecclesiasticus/5";
import ecclesiasticus_6 from "./ecclesiasticus/6";
import ecclesiasticus_7 from "./ecclesiasticus/7";
import ecclesiasticus_8 from "./ecclesiasticus/8";
import ecclesiasticus_9 from "./ecclesiasticus/9";
import ecclesiasticus_10 from "./ecclesiasticus/10";
import ecclesiasticus_11 from "./ecclesiasticus/11";
import ecclesiasticus_12 from "./ecclesiasticus/12";
import ecclesiasticus_13 from "./ecclesiasticus/13";
import ecclesiasticus_14 from "./ecclesiasticus/14";
import ecclesiasticus_15 from "./ecclesiasticus/15";
import ecclesiasticus_16 from "./ecclesiasticus/16";
import ecclesiasticus_17 from "./ecclesiasticus/17";
import ecclesiasticus_18 from "./ecclesiasticus/18";
import ecclesiasticus_19 from "./ecclesiasticus/19";
import ecclesiasticus_20 from "./ecclesiasticus/20";
import ecclesiasticus_21 from "./ecclesiasticus/21";
import ecclesiasticus_22 from "./ecclesiasticus/22";
import ecclesiasticus_23 from "./ecclesiasticus/23";
import ecclesiasticus_24 from "./ecclesiasticus/24";
import ecclesiasticus_25 from "./ecclesiasticus/25";
import ecclesiasticus_26 from "./ecclesiasticus/26";
import ecclesiasticus_27 from "./ecclesiasticus/27";
import ecclesiasticus_28 from "./ecclesiasticus/28";
import ecclesiasticus_29 from "./ecclesiasticus/29";
import ecclesiasticus_30 from "./ecclesiasticus/30";
import ecclesiasticus_31 from "./ecclesiasticus/31";
import ecclesiasticus_32 from "./ecclesiasticus/32";
import ecclesiasticus_33 from "./ecclesiasticus/33";
import ecclesiasticus_34 from "./ecclesiasticus/34";
import ecclesiasticus_35 from "./ecclesiasticus/35";
import ecclesiasticus_36 from "./ecclesiasticus/36";
import ecclesiasticus_37 from "./ecclesiasticus/37";
import ecclesiasticus_38 from "./ecclesiasticus/38";
import ecclesiasticus_39 from "./ecclesiasticus/39";
import ecclesiasticus_40 from "./ecclesiasticus/40";
import ecclesiasticus_41 from "./ecclesiasticus/41";
import ecclesiasticus_42 from "./ecclesiasticus/42";
import ecclesiasticus_43 from "./ecclesiasticus/43";
import ecclesiasticus_44 from "./ecclesiasticus/44";
import ecclesiasticus_45 from "./ecclesiasticus/45";
import ecclesiasticus_46 from "./ecclesiasticus/46";
import ecclesiasticus_47 from "./ecclesiasticus/47";
import ecclesiasticus_48 from "./ecclesiasticus/48";
import ecclesiasticus_49 from "./ecclesiasticus/49";
import ecclesiasticus_50 from "./ecclesiasticus/50";
import ecclesiasticus_51 from "./ecclesiasticus/51";
import ephesians_1 from "./ephesians/1";
import ephesians_2 from "./ephesians/2";
import ephesians_3 from "./ephesians/3";
import ephesians_4 from "./ephesians/4";
import ephesians_5 from "./ephesians/5";
import ephesians_6 from "./ephesians/6";
import esther_1 from "./esther/1";
import esther_2 from "./esther/2";
import esther_3 from "./esther/3";
import esther_4 from "./esther/4";
import esther_5 from "./esther/5";
import esther_6 from "./esther/6";
import esther_7 from "./esther/7";
import esther_8 from "./esther/8";
import esther_9 from "./esther/9";
import esther_10 from "./esther/10";
import esther_11 from "./esther/11";
import esther_12 from "./esther/12";
import esther_13 from "./esther/13";
import esther_14 from "./esther/14";
import esther_15 from "./esther/15";
import esther_16 from "./esther/16";
import exodus_1 from "./exodus/1";
import exodus_2 from "./exodus/2";
import exodus_3 from "./exodus/3";
import exodus_4 from "./exodus/4";
import exodus_5 from "./exodus/5";
import exodus_6 from "./exodus/6";
import exodus_7 from "./exodus/7";
import exodus_8 from "./exodus/8";
import exodus_9 from "./exodus/9";
import exodus_10 from "./exodus/10";
import exodus_11 from "./exodus/11";
import exodus_12 from "./exodus/12";
import exodus_13 from "./exodus/13";
import exodus_14 from "./exodus/14";
import exodus_15 from "./exodus/15";
import exodus_16 from "./exodus/16";
import exodus_17 from "./exodus/17";
import exodus_18 from "./exodus/18";
import exodus_19 from "./exodus/19";
import exodus_20 from "./exodus/20";
import exodus_21 from "./exodus/21";
import exodus_22 from "./exodus/22";
import exodus_23 from "./exodus/23";
import exodus_24 from "./exodus/24";
import exodus_25 from "./exodus/25";
import exodus_26 from "./exodus/26";
import exodus_27 from "./exodus/27";
import exodus_28 from "./exodus/28";
import exodus_29 from "./exodus/29";
import exodus_30 from "./exodus/30";
import exodus_31 from "./exodus/31";
import exodus_32 from "./exodus/32";
import exodus_33 from "./exodus/33";
import exodus_34 from "./exodus/34";
import exodus_35 from "./exodus/35";
import exodus_36 from "./exodus/36";
import exodus_37 from "./exodus/37";
import exodus_38 from "./exodus/38";
import exodus_39 from "./exodus/39";
import exodus_40 from "./exodus/40";
import ezechiel_1 from "./ezechiel/1";
import ezechiel_2 from "./ezechiel/2";
import ezechiel_3 from "./ezechiel/3";
import ezechiel_4 from "./ezechiel/4";
import ezechiel_5 from "./ezechiel/5";
import ezechiel_6 from "./ezechiel/6";
import ezechiel_7 from "./ezechiel/7";
import ezechiel_8 from "./ezechiel/8";
import ezechiel_9 from "./ezechiel/9";
import ezechiel_10 from "./ezechiel/10";
import ezechiel_11 from "./ezechiel/11";
import ezechiel_12 from "./ezechiel/12";
import ezechiel_13 from "./ezechiel/13";
import ezechiel_14 from "./ezechiel/14";
import ezechiel_15 from "./ezechiel/15";
import ezechiel_16 from "./ezechiel/16";
import ezechiel_17 from "./ezechiel/17";
import ezechiel_18 from "./ezechiel/18";
import ezechiel_19 from "./ezechiel/19";
import ezechiel_20 from "./ezechiel/20";
import ezechiel_21 from "./ezechiel/21";
import ezechiel_22 from "./ezechiel/22";
import ezechiel_23 from "./ezechiel/23";
import ezechiel_24 from "./ezechiel/24";
import ezechiel_25 from "./ezechiel/25";
import ezechiel_26 from "./ezechiel/26";
import ezechiel_27 from "./ezechiel/27";
import ezechiel_28 from "./ezechiel/28";
import ezechiel_29 from "./ezechiel/29";
import ezechiel_30 from "./ezechiel/30";
import ezechiel_31 from "./ezechiel/31";
import ezechiel_32 from "./ezechiel/32";
import ezechiel_33 from "./ezechiel/33";
import ezechiel_34 from "./ezechiel/34";
import ezechiel_35 from "./ezechiel/35";
import ezechiel_36 from "./ezechiel/36";
import ezechiel_37 from "./ezechiel/37";
import ezechiel_38 from "./ezechiel/38";
import ezechiel_39 from "./ezechiel/39";
import ezechiel_40 from "./ezechiel/40";
import ezechiel_41 from "./ezechiel/41";
import ezechiel_42 from "./ezechiel/42";
import ezechiel_43 from "./ezechiel/43";
import ezechiel_44 from "./ezechiel/44";
import ezechiel_45 from "./ezechiel/45";
import ezechiel_46 from "./ezechiel/46";
import ezechiel_47 from "./ezechiel/47";
import ezechiel_48 from "./ezechiel/48";
import galatians_1 from "./galatians/1";
import galatians_2 from "./galatians/2";
import galatians_3 from "./galatians/3";
import galatians_4 from "./galatians/4";
import galatians_5 from "./galatians/5";
import galatians_6 from "./galatians/6";
import genesis_1 from "./genesis/1";
import genesis_2 from "./genesis/2";
import genesis_3 from "./genesis/3";
import genesis_4 from "./genesis/4";
import genesis_5 from "./genesis/5";
import genesis_6 from "./genesis/6";
import genesis_7 from "./genesis/7";
import genesis_8 from "./genesis/8";
import genesis_9 from "./genesis/9";
import genesis_10 from "./genesis/10";
import genesis_11 from "./genesis/11";
import genesis_12 from "./genesis/12";
import genesis_13 from "./genesis/13";
import genesis_14 from "./genesis/14";
import genesis_15 from "./genesis/15";
import genesis_16 from "./genesis/16";
import genesis_17 from "./genesis/17";
import genesis_18 from "./genesis/18";
import genesis_19 from "./genesis/19";
import genesis_20 from "./genesis/20";
import genesis_21 from "./genesis/21";
import genesis_22 from "./genesis/22";
import genesis_23 from "./genesis/23";
import genesis_24 from "./genesis/24";
import genesis_25 from "./genesis/25";
import genesis_26 from "./genesis/26";
import genesis_27 from "./genesis/27";
import genesis_28 from "./genesis/28";
import genesis_29 from "./genesis/29";
import genesis_30 from "./genesis/30";
import genesis_31 from "./genesis/31";
import genesis_32 from "./genesis/32";
import genesis_33 from "./genesis/33";
import genesis_34 from "./genesis/34";
import genesis_35 from "./genesis/35";
import genesis_36 from "./genesis/36";
import genesis_37 from "./genesis/37";
import genesis_38 from "./genesis/38";
import genesis_39 from "./genesis/39";
import genesis_40 from "./genesis/40";
import genesis_41 from "./genesis/41";
import genesis_42 from "./genesis/42";
import genesis_43 from "./genesis/43";
import genesis_44 from "./genesis/44";
import genesis_45 from "./genesis/45";
import genesis_46 from "./genesis/46";
import genesis_47 from "./genesis/47";
import genesis_48 from "./genesis/48";
import genesis_49 from "./genesis/49";
import genesis_50 from "./genesis/50";
import habacuc_1 from "./habacuc/1";
import habacuc_2 from "./habacuc/2";
import habacuc_3 from "./habacuc/3";
import hebrews_1 from "./hebrews/1";
import hebrews_2 from "./hebrews/2";
import hebrews_3 from "./hebrews/3";
import hebrews_4 from "./hebrews/4";
import hebrews_5 from "./hebrews/5";
import hebrews_6 from "./hebrews/6";
import hebrews_7 from "./hebrews/7";
import hebrews_8 from "./hebrews/8";
import hebrews_9 from "./hebrews/9";
import hebrews_10 from "./hebrews/10";
import hebrews_11 from "./hebrews/11";
import hebrews_12 from "./hebrews/12";
import hebrews_13 from "./hebrews/13";
import isaias_1 from "./isaias/1";
import isaias_2 from "./isaias/2";
import isaias_3 from "./isaias/3";
import isaias_4 from "./isaias/4";
import isaias_5 from "./isaias/5";
import isaias_6 from "./isaias/6";
import isaias_7 from "./isaias/7";
import isaias_8 from "./isaias/8";
import isaias_9 from "./isaias/9";
import isaias_10 from "./isaias/10";
import isaias_11 from "./isaias/11";
import isaias_12 from "./isaias/12";
import isaias_13 from "./isaias/13";
import isaias_14 from "./isaias/14";
import isaias_15 from "./isaias/15";
import isaias_16 from "./isaias/16";
import isaias_17 from "./isaias/17";
import isaias_18 from "./isaias/18";
import isaias_19 from "./isaias/19";
import isaias_20 from "./isaias/20";
import isaias_21 from "./isaias/21";
import isaias_22 from "./isaias/22";
import isaias_23 from "./isaias/23";
import isaias_24 from "./isaias/24";
import isaias_25 from "./isaias/25";
import isaias_26 from "./isaias/26";
import isaias_27 from "./isaias/27";
import isaias_28 from "./isaias/28";
import isaias_29 from "./isaias/29";
import isaias_30 from "./isaias/30";
import isaias_31 from "./isaias/31";
import isaias_32 from "./isaias/32";
import isaias_33 from "./isaias/33";
import isaias_34 from "./isaias/34";
import isaias_35 from "./isaias/35";
import isaias_36 from "./isaias/36";
import isaias_37 from "./isaias/37";
import isaias_38 from "./isaias/38";
import isaias_39 from "./isaias/39";
import isaias_40 from "./isaias/40";
import isaias_41 from "./isaias/41";
import isaias_42 from "./isaias/42";
import isaias_43 from "./isaias/43";
import isaias_44 from "./isaias/44";
import isaias_45 from "./isaias/45";
import isaias_46 from "./isaias/46";
import isaias_47 from "./isaias/47";
import isaias_48 from "./isaias/48";
import isaias_49 from "./isaias/49";
import isaias_50 from "./isaias/50";
import isaias_51 from "./isaias/51";
import isaias_52 from "./isaias/52";
import isaias_53 from "./isaias/53";
import isaias_54 from "./isaias/54";
import isaias_55 from "./isaias/55";
import isaias_56 from "./isaias/56";
import isaias_57 from "./isaias/57";
import isaias_58 from "./isaias/58";
import isaias_59 from "./isaias/59";
import isaias_60 from "./isaias/60";
import isaias_61 from "./isaias/61";
import isaias_62 from "./isaias/62";
import isaias_63 from "./isaias/63";
import isaias_64 from "./isaias/64";
import isaias_65 from "./isaias/65";
import isaias_66 from "./isaias/66";
import james_1 from "./james/1";
import james_2 from "./james/2";
import james_3 from "./james/3";
import james_4 from "./james/4";
import james_5 from "./james/5";
import jeremias_1 from "./jeremias/1";
import jeremias_2 from "./jeremias/2";
import jeremias_3 from "./jeremias/3";
import jeremias_4 from "./jeremias/4";
import jeremias_5 from "./jeremias/5";
import jeremias_6 from "./jeremias/6";
import jeremias_7 from "./jeremias/7";
import jeremias_8 from "./jeremias/8";
import jeremias_9 from "./jeremias/9";
import jeremias_10 from "./jeremias/10";
import jeremias_11 from "./jeremias/11";
import jeremias_12 from "./jeremias/12";
import jeremias_13 from "./jeremias/13";
import jeremias_14 from "./jeremias/14";
import jeremias_15 from "./jeremias/15";
import jeremias_16 from "./jeremias/16";
import jeremias_17 from "./jeremias/17";
import jeremias_18 from "./jeremias/18";
import jeremias_19 from "./jeremias/19";
import jeremias_20 from "./jeremias/20";
import jeremias_21 from "./jeremias/21";
import jeremias_22 from "./jeremias/22";
import jeremias_23 from "./jeremias/23";
import jeremias_24 from "./jeremias/24";
import jeremias_25 from "./jeremias/25";
import jeremias_26 from "./jeremias/26";
import jeremias_27 from "./jeremias/27";
import jeremias_28 from "./jeremias/28";
import jeremias_29 from "./jeremias/29";
import jeremias_30 from "./jeremias/30";
import jeremias_31 from "./jeremias/31";
import jeremias_32 from "./jeremias/32";
import jeremias_33 from "./jeremias/33";
import jeremias_34 from "./jeremias/34";
import jeremias_35 from "./jeremias/35";
import jeremias_36 from "./jeremias/36";
import jeremias_37 from "./jeremias/37";
import jeremias_38 from "./jeremias/38";
import jeremias_39 from "./jeremias/39";
import jeremias_40 from "./jeremias/40";
import jeremias_41 from "./jeremias/41";
import jeremias_42 from "./jeremias/42";
import jeremias_43 from "./jeremias/43";
import jeremias_44 from "./jeremias/44";
import jeremias_45 from "./jeremias/45";
import jeremias_46 from "./jeremias/46";
import jeremias_47 from "./jeremias/47";
import jeremias_48 from "./jeremias/48";
import jeremias_49 from "./jeremias/49";
import jeremias_50 from "./jeremias/50";
import jeremias_51 from "./jeremias/51";
import jeremias_52 from "./jeremias/52";
import job_1 from "./job/1";
import job_2 from "./job/2";
import job_3 from "./job/3";
import job_4 from "./job/4";
import job_5 from "./job/5";
import job_6 from "./job/6";
import job_7 from "./job/7";
import job_8 from "./job/8";
import job_9 from "./job/9";
import job_10 from "./job/10";
import job_11 from "./job/11";
import job_12 from "./job/12";
import job_13 from "./job/13";
import job_14 from "./job/14";
import job_15 from "./job/15";
import job_16 from "./job/16";
import job_17 from "./job/17";
import job_18 from "./job/18";
import job_19 from "./job/19";
import job_20 from "./job/20";
import job_21 from "./job/21";
import job_22 from "./job/22";
import job_23 from "./job/23";
import job_24 from "./job/24";
import job_25 from "./job/25";
import job_26 from "./job/26";
import job_27 from "./job/27";
import job_28 from "./job/28";
import job_29 from "./job/29";
import job_30 from "./job/30";
import job_31 from "./job/31";
import job_32 from "./job/32";
import job_33 from "./job/33";
import job_34 from "./job/34";
import job_35 from "./job/35";
import job_36 from "./job/36";
import job_37 from "./job/37";
import job_38 from "./job/38";
import job_39 from "./job/39";
import job_40 from "./job/40";
import job_41 from "./job/41";
import job_42 from "./job/42";
import joel_1 from "./joel/1";
import joel_2 from "./joel/2";
import joel_3 from "./joel/3";
import john_1 from "./john/1";
import john_2 from "./john/2";
import john_3 from "./john/3";
import john_4 from "./john/4";
import john_5 from "./john/5";
import john_6 from "./john/6";
import john_7 from "./john/7";
import john_8 from "./john/8";
import john_9 from "./john/9";
import john_10 from "./john/10";
import john_11 from "./john/11";
import john_12 from "./john/12";
import john_13 from "./john/13";
import john_14 from "./john/14";
import john_15 from "./john/15";
import john_16 from "./john/16";
import john_17 from "./john/17";
import john_18 from "./john/18";
import john_19 from "./john/19";
import john_20 from "./john/20";
import john_21 from "./john/21";
import jonas_1 from "./jonas/1";
import jonas_2 from "./jonas/2";
import jonas_3 from "./jonas/3";
import jonas_4 from "./jonas/4";
import josue_1 from "./josue/1";
import josue_2 from "./josue/2";
import josue_3 from "./josue/3";
import josue_4 from "./josue/4";
import josue_5 from "./josue/5";
import josue_6 from "./josue/6";
import josue_7 from "./josue/7";
import josue_8 from "./josue/8";
import josue_9 from "./josue/9";
import josue_10 from "./josue/10";
import josue_11 from "./josue/11";
import josue_12 from "./josue/12";
import josue_13 from "./josue/13";
import josue_14 from "./josue/14";
import josue_15 from "./josue/15";
import josue_16 from "./josue/16";
import josue_17 from "./josue/17";
import josue_18 from "./josue/18";
import josue_19 from "./josue/19";
import josue_20 from "./josue/20";
import josue_21 from "./josue/21";
import josue_22 from "./josue/22";
import josue_23 from "./josue/23";
import josue_24 from "./josue/24";
import jude_1 from "./jude/1";
import judges_1 from "./judges/1";
import judges_2 from "./judges/2";
import judges_3 from "./judges/3";
import judges_4 from "./judges/4";
import judges_5 from "./judges/5";
import judges_6 from "./judges/6";
import judges_7 from "./judges/7";
import judges_8 from "./judges/8";
import judges_9 from "./judges/9";
import judges_10 from "./judges/10";
import judges_11 from "./judges/11";
import judges_12 from "./judges/12";
import judges_13 from "./judges/13";
import judges_14 from "./judges/14";
import judges_15 from "./judges/15";
import judges_16 from "./judges/16";
import judges_17 from "./judges/17";
import judges_18 from "./judges/18";
import judges_19 from "./judges/19";
import judges_20 from "./judges/20";
import judges_21 from "./judges/21";
import judith_1 from "./judith/1";
import judith_2 from "./judith/2";
import judith_3 from "./judith/3";
import judith_4 from "./judith/4";
import judith_5 from "./judith/5";
import judith_6 from "./judith/6";
import judith_7 from "./judith/7";
import judith_8 from "./judith/8";
import judith_9 from "./judith/9";
import judith_10 from "./judith/10";
import judith_11 from "./judith/11";
import judith_12 from "./judith/12";
import judith_13 from "./judith/13";
import judith_14 from "./judith/14";
import judith_15 from "./judith/15";
import judith_16 from "./judith/16";
import lamentations_1 from "./lamentations/1";
import lamentations_2 from "./lamentations/2";
import lamentations_3 from "./lamentations/3";
import lamentations_4 from "./lamentations/4";
import lamentations_5 from "./lamentations/5";
import leviticus_1 from "./leviticus/1";
import leviticus_2 from "./leviticus/2";
import leviticus_3 from "./leviticus/3";
import leviticus_4 from "./leviticus/4";
import leviticus_5 from "./leviticus/5";
import leviticus_6 from "./leviticus/6";
import leviticus_7 from "./leviticus/7";
import leviticus_8 from "./leviticus/8";
import leviticus_9 from "./leviticus/9";
import leviticus_10 from "./leviticus/10";
import leviticus_11 from "./leviticus/11";
import leviticus_12 from "./leviticus/12";
import leviticus_13 from "./leviticus/13";
import leviticus_14 from "./leviticus/14";
import leviticus_15 from "./leviticus/15";
import leviticus_16 from "./leviticus/16";
import leviticus_17 from "./leviticus/17";
import leviticus_18 from "./leviticus/18";
import leviticus_19 from "./leviticus/19";
import leviticus_20 from "./leviticus/20";
import leviticus_21 from "./leviticus/21";
import leviticus_22 from "./leviticus/22";
import leviticus_23 from "./leviticus/23";
import leviticus_24 from "./leviticus/24";
import leviticus_25 from "./leviticus/25";
import leviticus_26 from "./leviticus/26";
import leviticus_27 from "./leviticus/27";
import luke_1 from "./luke/1";
import luke_2 from "./luke/2";
import luke_3 from "./luke/3";
import luke_4 from "./luke/4";
import luke_5 from "./luke/5";
import luke_6 from "./luke/6";
import luke_7 from "./luke/7";
import luke_8 from "./luke/8";
import luke_9 from "./luke/9";
import luke_10 from "./luke/10";
import luke_11 from "./luke/11";
import luke_12 from "./luke/12";
import luke_13 from "./luke/13";
import luke_14 from "./luke/14";
import luke_15 from "./luke/15";
import luke_16 from "./luke/16";
import luke_17 from "./luke/17";
import luke_18 from "./luke/18";
import luke_19 from "./luke/19";
import luke_20 from "./luke/20";
import luke_21 from "./luke/21";
import luke_22 from "./luke/22";
import luke_23 from "./luke/23";
import luke_24 from "./luke/24";
import malachias_1 from "./malachias/1";
import malachias_2 from "./malachias/2";
import malachias_3 from "./malachias/3";
import malachias_4 from "./malachias/4";
import mark_1 from "./mark/1";
import mark_2 from "./mark/2";
import mark_3 from "./mark/3";
import mark_4 from "./mark/4";
import mark_5 from "./mark/5";
import mark_6 from "./mark/6";
import mark_7 from "./mark/7";
import mark_8 from "./mark/8";
import mark_9 from "./mark/9";
import mark_10 from "./mark/10";
import mark_11 from "./mark/11";
import mark_12 from "./mark/12";
import mark_13 from "./mark/13";
import mark_14 from "./mark/14";
import mark_15 from "./mark/15";
import mark_16 from "./mark/16";
import matthew_1 from "./matthew/1";
import matthew_2 from "./matthew/2";
import matthew_3 from "./matthew/3";
import matthew_4 from "./matthew/4";
import matthew_5 from "./matthew/5";
import matthew_6 from "./matthew/6";
import matthew_7 from "./matthew/7";
import matthew_8 from "./matthew/8";
import matthew_9 from "./matthew/9";
import matthew_10 from "./matthew/10";
import matthew_11 from "./matthew/11";
import matthew_12 from "./matthew/12";
import matthew_13 from "./matthew/13";
import matthew_14 from "./matthew/14";
import matthew_15 from "./matthew/15";
import matthew_16 from "./matthew/16";
import matthew_17 from "./matthew/17";
import matthew_18 from "./matthew/18";
import matthew_19 from "./matthew/19";
import matthew_20 from "./matthew/20";
import matthew_21 from "./matthew/21";
import matthew_22 from "./matthew/22";
import matthew_23 from "./matthew/23";
import matthew_24 from "./matthew/24";
import matthew_25 from "./matthew/25";
import matthew_26 from "./matthew/26";
import matthew_27 from "./matthew/27";
import matthew_28 from "./matthew/28";
import micheas_1 from "./micheas/1";
import micheas_2 from "./micheas/2";
import micheas_3 from "./micheas/3";
import micheas_4 from "./micheas/4";
import micheas_5 from "./micheas/5";
import micheas_6 from "./micheas/6";
import micheas_7 from "./micheas/7";
import nahum_1 from "./nahum/1";
import nahum_2 from "./nahum/2";
import nahum_3 from "./nahum/3";
import numbers_1 from "./numbers/1";
import numbers_2 from "./numbers/2";
import numbers_3 from "./numbers/3";
import numbers_4 from "./numbers/4";
import numbers_5 from "./numbers/5";
import numbers_6 from "./numbers/6";
import numbers_7 from "./numbers/7";
import numbers_8 from "./numbers/8";
import numbers_9 from "./numbers/9";
import numbers_10 from "./numbers/10";
import numbers_11 from "./numbers/11";
import numbers_12 from "./numbers/12";
import numbers_13 from "./numbers/13";
import numbers_14 from "./numbers/14";
import numbers_15 from "./numbers/15";
import numbers_16 from "./numbers/16";
import numbers_17 from "./numbers/17";
import numbers_18 from "./numbers/18";
import numbers_19 from "./numbers/19";
import numbers_20 from "./numbers/20";
import numbers_21 from "./numbers/21";
import numbers_22 from "./numbers/22";
import numbers_23 from "./numbers/23";
import numbers_24 from "./numbers/24";
import numbers_25 from "./numbers/25";
import numbers_26 from "./numbers/26";
import numbers_27 from "./numbers/27";
import numbers_28 from "./numbers/28";
import numbers_29 from "./numbers/29";
import numbers_30 from "./numbers/30";
import numbers_31 from "./numbers/31";
import numbers_32 from "./numbers/32";
import numbers_33 from "./numbers/33";
import numbers_34 from "./numbers/34";
import numbers_35 from "./numbers/35";
import numbers_36 from "./numbers/36";
import osee_1 from "./osee/1";
import osee_2 from "./osee/2";
import osee_3 from "./osee/3";
import osee_4 from "./osee/4";
import osee_5 from "./osee/5";
import osee_6 from "./osee/6";
import osee_7 from "./osee/7";
import osee_8 from "./osee/8";
import osee_9 from "./osee/9";
import osee_10 from "./osee/10";
import osee_11 from "./osee/11";
import osee_12 from "./osee/12";
import osee_13 from "./osee/13";
import osee_14 from "./osee/14";
import philemon_1 from "./philemon/1";
import philippians_1 from "./philippians/1";
import philippians_2 from "./philippians/2";
import philippians_3 from "./philippians/3";
import philippians_4 from "./philippians/4";
import proverbs_1 from "./proverbs/1";
import proverbs_2 from "./proverbs/2";
import proverbs_3 from "./proverbs/3";
import proverbs_4 from "./proverbs/4";
import proverbs_5 from "./proverbs/5";
import proverbs_6 from "./proverbs/6";
import proverbs_7 from "./proverbs/7";
import proverbs_8 from "./proverbs/8";
import proverbs_9 from "./proverbs/9";
import proverbs_10 from "./proverbs/10";
import proverbs_11 from "./proverbs/11";
import proverbs_12 from "./proverbs/12";
import proverbs_13 from "./proverbs/13";
import proverbs_14 from "./proverbs/14";
import proverbs_15 from "./proverbs/15";
import proverbs_16 from "./proverbs/16";
import proverbs_17 from "./proverbs/17";
import proverbs_18 from "./proverbs/18";
import proverbs_19 from "./proverbs/19";
import proverbs_20 from "./proverbs/20";
import proverbs_21 from "./proverbs/21";
import proverbs_22 from "./proverbs/22";
import proverbs_23 from "./proverbs/23";
import proverbs_24 from "./proverbs/24";
import proverbs_25 from "./proverbs/25";
import proverbs_26 from "./proverbs/26";
import proverbs_27 from "./proverbs/27";
import proverbs_28 from "./proverbs/28";
import proverbs_29 from "./proverbs/29";
import proverbs_30 from "./proverbs/30";
import proverbs_31 from "./proverbs/31";
import psalms_1 from "./psalms/1";
import psalms_2 from "./psalms/2";
import psalms_3 from "./psalms/3";
import psalms_4 from "./psalms/4";
import psalms_5 from "./psalms/5";
import psalms_6 from "./psalms/6";
import psalms_7 from "./psalms/7";
import psalms_8 from "./psalms/8";
import psalms_9 from "./psalms/9";
import psalms_10 from "./psalms/10";
import psalms_11 from "./psalms/11";
import psalms_12 from "./psalms/12";
import psalms_13 from "./psalms/13";
import psalms_14 from "./psalms/14";
import psalms_15 from "./psalms/15";
import psalms_16 from "./psalms/16";
import psalms_17 from "./psalms/17";
import psalms_18 from "./psalms/18";
import psalms_19 from "./psalms/19";
import psalms_20 from "./psalms/20";
import psalms_21 from "./psalms/21";
import psalms_22 from "./psalms/22";
import psalms_23 from "./psalms/23";
import psalms_24 from "./psalms/24";
import psalms_25 from "./psalms/25";
import psalms_26 from "./psalms/26";
import psalms_27 from "./psalms/27";
import psalms_28 from "./psalms/28";
import psalms_29 from "./psalms/29";
import psalms_30 from "./psalms/30";
import psalms_31 from "./psalms/31";
import psalms_32 from "./psalms/32";
import psalms_33 from "./psalms/33";
import psalms_34 from "./psalms/34";
import psalms_35 from "./psalms/35";
import psalms_36 from "./psalms/36";
import psalms_37 from "./psalms/37";
import psalms_38 from "./psalms/38";
import psalms_39 from "./psalms/39";
import psalms_40 from "./psalms/40";
import psalms_41 from "./psalms/41";
import psalms_42 from "./psalms/42";
import psalms_43 from "./psalms/43";
import psalms_44 from "./psalms/44";
import psalms_45 from "./psalms/45";
import psalms_46 from "./psalms/46";
import psalms_47 from "./psalms/47";
import psalms_48 from "./psalms/48";
import psalms_49 from "./psalms/49";
import psalms_50 from "./psalms/50";
import psalms_51 from "./psalms/51";
import psalms_52 from "./psalms/52";
import psalms_53 from "./psalms/53";
import psalms_54 from "./psalms/54";
import psalms_55 from "./psalms/55";
import psalms_56 from "./psalms/56";
import psalms_57 from "./psalms/57";
import psalms_58 from "./psalms/58";
import psalms_59 from "./psalms/59";
import psalms_60 from "./psalms/60";
import psalms_61 from "./psalms/61";
import psalms_62 from "./psalms/62";
import psalms_63 from "./psalms/63";
import psalms_64 from "./psalms/64";
import psalms_65 from "./psalms/65";
import psalms_66 from "./psalms/66";
import psalms_67 from "./psalms/67";
import psalms_68 from "./psalms/68";
import psalms_69 from "./psalms/69";
import psalms_70 from "./psalms/70";
import psalms_71 from "./psalms/71";
import psalms_72 from "./psalms/72";
import psalms_73 from "./psalms/73";
import psalms_74 from "./psalms/74";
import psalms_75 from "./psalms/75";
import psalms_76 from "./psalms/76";
import psalms_77 from "./psalms/77";
import psalms_78 from "./psalms/78";
import psalms_79 from "./psalms/79";
import psalms_80 from "./psalms/80";
import psalms_81 from "./psalms/81";
import psalms_82 from "./psalms/82";
import psalms_83 from "./psalms/83";
import psalms_84 from "./psalms/84";
import psalms_85 from "./psalms/85";
import psalms_86 from "./psalms/86";
import psalms_87 from "./psalms/87";
import psalms_88 from "./psalms/88";
import psalms_89 from "./psalms/89";
import psalms_90 from "./psalms/90";
import psalms_91 from "./psalms/91";
import psalms_92 from "./psalms/92";
import psalms_93 from "./psalms/93";
import psalms_94 from "./psalms/94";
import psalms_95 from "./psalms/95";
import psalms_96 from "./psalms/96";
import psalms_97 from "./psalms/97";
import psalms_98 from "./psalms/98";
import psalms_99 from "./psalms/99";
import psalms_100 from "./psalms/100";
import psalms_101 from "./psalms/101";
import psalms_102 from "./psalms/102";
import psalms_103 from "./psalms/103";
import psalms_104 from "./psalms/104";
import psalms_105 from "./psalms/105";
import psalms_106 from "./psalms/106";
import psalms_107 from "./psalms/107";
import psalms_108 from "./psalms/108";
import psalms_109 from "./psalms/109";
import psalms_110 from "./psalms/110";
import psalms_111 from "./psalms/111";
import psalms_112 from "./psalms/112";
import psalms_113 from "./psalms/113";
import psalms_114 from "./psalms/114";
import psalms_115 from "./psalms/115";
import psalms_116 from "./psalms/116";
import psalms_117 from "./psalms/117";
import psalms_118 from "./psalms/118";
import psalms_119 from "./psalms/119";
import psalms_120 from "./psalms/120";
import psalms_121 from "./psalms/121";
import psalms_122 from "./psalms/122";
import psalms_123 from "./psalms/123";
import psalms_124 from "./psalms/124";
import psalms_125 from "./psalms/125";
import psalms_126 from "./psalms/126";
import psalms_127 from "./psalms/127";
import psalms_128 from "./psalms/128";
import psalms_129 from "./psalms/129";
import psalms_130 from "./psalms/130";
import psalms_131 from "./psalms/131";
import psalms_132 from "./psalms/132";
import psalms_133 from "./psalms/133";
import psalms_134 from "./psalms/134";
import psalms_135 from "./psalms/135";
import psalms_136 from "./psalms/136";
import psalms_137 from "./psalms/137";
import psalms_138 from "./psalms/138";
import psalms_139 from "./psalms/139";
import psalms_140 from "./psalms/140";
import psalms_141 from "./psalms/141";
import psalms_142 from "./psalms/142";
import psalms_143 from "./psalms/143";
import psalms_144 from "./psalms/144";
import psalms_145 from "./psalms/145";
import psalms_146 from "./psalms/146";
import psalms_147 from "./psalms/147";
import psalms_148 from "./psalms/148";
import psalms_149 from "./psalms/149";
import psalms_150 from "./psalms/150";
import romans_1 from "./romans/1";
import romans_2 from "./romans/2";
import romans_3 from "./romans/3";
import romans_4 from "./romans/4";
import romans_5 from "./romans/5";
import romans_6 from "./romans/6";
import romans_7 from "./romans/7";
import romans_8 from "./romans/8";
import romans_9 from "./romans/9";
import romans_10 from "./romans/10";
import romans_11 from "./romans/11";
import romans_12 from "./romans/12";
import romans_13 from "./romans/13";
import romans_14 from "./romans/14";
import romans_15 from "./romans/15";
import romans_16 from "./romans/16";
import ruth_1 from "./ruth/1";
import ruth_2 from "./ruth/2";
import ruth_3 from "./ruth/3";
import ruth_4 from "./ruth/4";
import sophonias_1 from "./sophonias/1";
import sophonias_2 from "./sophonias/2";
import sophonias_3 from "./sophonias/3";
import titus_1 from "./titus/1";
import titus_2 from "./titus/2";
import titus_3 from "./titus/3";
import tobias_1 from "./tobias/1";
import tobias_2 from "./tobias/2";
import tobias_3 from "./tobias/3";
import tobias_4 from "./tobias/4";
import tobias_5 from "./tobias/5";
import tobias_6 from "./tobias/6";
import tobias_7 from "./tobias/7";
import tobias_8 from "./tobias/8";
import tobias_9 from "./tobias/9";
import tobias_10 from "./tobias/10";
import tobias_11 from "./tobias/11";
import tobias_12 from "./tobias/12";
import tobias_13 from "./tobias/13";
import tobias_14 from "./tobias/14";
import wisdom_1 from "./wisdom/1";
import wisdom_2 from "./wisdom/2";
import wisdom_3 from "./wisdom/3";
import wisdom_4 from "./wisdom/4";
import wisdom_5 from "./wisdom/5";
import wisdom_6 from "./wisdom/6";
import wisdom_7 from "./wisdom/7";
import wisdom_8 from "./wisdom/8";
import wisdom_9 from "./wisdom/9";
import wisdom_10 from "./wisdom/10";
import wisdom_11 from "./wisdom/11";
import wisdom_12 from "./wisdom/12";
import wisdom_13 from "./wisdom/13";
import wisdom_14 from "./wisdom/14";
import wisdom_15 from "./wisdom/15";
import wisdom_16 from "./wisdom/16";
import wisdom_17 from "./wisdom/17";
import wisdom_18 from "./wisdom/18";
import wisdom_19 from "./wisdom/19";
import zacharias_1 from "./zacharias/1";
import zacharias_2 from "./zacharias/2";
import zacharias_3 from "./zacharias/3";
import zacharias_4 from "./zacharias/4";
import zacharias_5 from "./zacharias/5";
import zacharias_6 from "./zacharias/6";
import zacharias_7 from "./zacharias/7";
import zacharias_8 from "./zacharias/8";
import zacharias_9 from "./zacharias/9";
import zacharias_10 from "./zacharias/10";
import zacharias_11 from "./zacharias/11";
import zacharias_12 from "./zacharias/12";
import zacharias_13 from "./zacharias/13";
import zacharias_14 from "./zacharias/14";

const CHAPTERS = {
  "1-corinthians": {
    1: _1_corinthians_1,
    2: _1_corinthians_2,
    3: _1_corinthians_3,
    4: _1_corinthians_4,
    5: _1_corinthians_5,
    6: _1_corinthians_6,
    7: _1_corinthians_7,
    8: _1_corinthians_8,
    9: _1_corinthians_9,
    10: _1_corinthians_10,
    11: _1_corinthians_11,
    12: _1_corinthians_12,
    13: _1_corinthians_13,
    14: _1_corinthians_14,
    15: _1_corinthians_15,
    16: _1_corinthians_16,
  },
  "1-esdras": {
    1: _1_esdras_1,
    2: _1_esdras_2,
    3: _1_esdras_3,
    4: _1_esdras_4,
    5: _1_esdras_5,
    6: _1_esdras_6,
    7: _1_esdras_7,
    8: _1_esdras_8,
    9: _1_esdras_9,
    10: _1_esdras_10,
  },
  "1-john": {
    1: _1_john_1,
    2: _1_john_2,
    3: _1_john_3,
    4: _1_john_4,
    5: _1_john_5,
  },
  "1-kings": {
    1: _1_kings_1,
    2: _1_kings_2,
    3: _1_kings_3,
    4: _1_kings_4,
    5: _1_kings_5,
    6: _1_kings_6,
    7: _1_kings_7,
    8: _1_kings_8,
    9: _1_kings_9,
    10: _1_kings_10,
    11: _1_kings_11,
    12: _1_kings_12,
    13: _1_kings_13,
    14: _1_kings_14,
    15: _1_kings_15,
    16: _1_kings_16,
    17: _1_kings_17,
    18: _1_kings_18,
    19: _1_kings_19,
    20: _1_kings_20,
    21: _1_kings_21,
    22: _1_kings_22,
    23: _1_kings_23,
    24: _1_kings_24,
    25: _1_kings_25,
    26: _1_kings_26,
    27: _1_kings_27,
    28: _1_kings_28,
    29: _1_kings_29,
    30: _1_kings_30,
    31: _1_kings_31,
  },
  "1-machabees": {
    1: _1_machabees_1,
    2: _1_machabees_2,
    3: _1_machabees_3,
    4: _1_machabees_4,
    5: _1_machabees_5,
    6: _1_machabees_6,
    7: _1_machabees_7,
    8: _1_machabees_8,
    9: _1_machabees_9,
    10: _1_machabees_10,
    11: _1_machabees_11,
    12: _1_machabees_12,
    13: _1_machabees_13,
    14: _1_machabees_14,
    15: _1_machabees_15,
    16: _1_machabees_16,
  },
  "1-paralipomenon": {
    1: _1_paralipomenon_1,
    2: _1_paralipomenon_2,
    3: _1_paralipomenon_3,
    4: _1_paralipomenon_4,
    5: _1_paralipomenon_5,
    6: _1_paralipomenon_6,
    7: _1_paralipomenon_7,
    8: _1_paralipomenon_8,
    9: _1_paralipomenon_9,
    10: _1_paralipomenon_10,
    11: _1_paralipomenon_11,
    12: _1_paralipomenon_12,
    13: _1_paralipomenon_13,
    14: _1_paralipomenon_14,
    15: _1_paralipomenon_15,
    16: _1_paralipomenon_16,
    17: _1_paralipomenon_17,
    18: _1_paralipomenon_18,
    19: _1_paralipomenon_19,
    20: _1_paralipomenon_20,
    21: _1_paralipomenon_21,
    22: _1_paralipomenon_22,
    23: _1_paralipomenon_23,
    24: _1_paralipomenon_24,
    25: _1_paralipomenon_25,
    26: _1_paralipomenon_26,
    27: _1_paralipomenon_27,
    28: _1_paralipomenon_28,
    29: _1_paralipomenon_29,
  },
  "1-peter": {
    1: _1_peter_1,
    2: _1_peter_2,
    3: _1_peter_3,
    4: _1_peter_4,
    5: _1_peter_5,
  },
  "1-thessalonians": {
    1: _1_thessalonians_1,
    2: _1_thessalonians_2,
    3: _1_thessalonians_3,
    4: _1_thessalonians_4,
    5: _1_thessalonians_5,
  },
  "1-timothy": {
    1: _1_timothy_1,
    2: _1_timothy_2,
    3: _1_timothy_3,
    4: _1_timothy_4,
    5: _1_timothy_5,
    6: _1_timothy_6,
  },
  "2-corinthians": {
    1: _2_corinthians_1,
    2: _2_corinthians_2,
    3: _2_corinthians_3,
    4: _2_corinthians_4,
    5: _2_corinthians_5,
    6: _2_corinthians_6,
    7: _2_corinthians_7,
    8: _2_corinthians_8,
    9: _2_corinthians_9,
    10: _2_corinthians_10,
    11: _2_corinthians_11,
    12: _2_corinthians_12,
    13: _2_corinthians_13,
  },
  "2-esdras": {
    1: _2_esdras_1,
    2: _2_esdras_2,
    3: _2_esdras_3,
    4: _2_esdras_4,
    5: _2_esdras_5,
    6: _2_esdras_6,
    7: _2_esdras_7,
    8: _2_esdras_8,
    9: _2_esdras_9,
    10: _2_esdras_10,
    11: _2_esdras_11,
    12: _2_esdras_12,
    13: _2_esdras_13,
  },
  "2-john": {
    1: _2_john_1,
  },
  "2-kings": {
    1: _2_kings_1,
    2: _2_kings_2,
    3: _2_kings_3,
    4: _2_kings_4,
    5: _2_kings_5,
    6: _2_kings_6,
    7: _2_kings_7,
    8: _2_kings_8,
    9: _2_kings_9,
    10: _2_kings_10,
    11: _2_kings_11,
    12: _2_kings_12,
    13: _2_kings_13,
    14: _2_kings_14,
    15: _2_kings_15,
    16: _2_kings_16,
    17: _2_kings_17,
    18: _2_kings_18,
    19: _2_kings_19,
    20: _2_kings_20,
    21: _2_kings_21,
    22: _2_kings_22,
    23: _2_kings_23,
    24: _2_kings_24,
  },
  "2-machabees": {
    1: _2_machabees_1,
    2: _2_machabees_2,
    3: _2_machabees_3,
    4: _2_machabees_4,
    5: _2_machabees_5,
    6: _2_machabees_6,
    7: _2_machabees_7,
    8: _2_machabees_8,
    9: _2_machabees_9,
    10: _2_machabees_10,
    11: _2_machabees_11,
    12: _2_machabees_12,
    13: _2_machabees_13,
    14: _2_machabees_14,
    15: _2_machabees_15,
  },
  "2-paralipomenon": {
    1: _2_paralipomenon_1,
    2: _2_paralipomenon_2,
    3: _2_paralipomenon_3,
    4: _2_paralipomenon_4,
    5: _2_paralipomenon_5,
    6: _2_paralipomenon_6,
    7: _2_paralipomenon_7,
    8: _2_paralipomenon_8,
    9: _2_paralipomenon_9,
    10: _2_paralipomenon_10,
    11: _2_paralipomenon_11,
    12: _2_paralipomenon_12,
    13: _2_paralipomenon_13,
    14: _2_paralipomenon_14,
    15: _2_paralipomenon_15,
    16: _2_paralipomenon_16,
    17: _2_paralipomenon_17,
    18: _2_paralipomenon_18,
    19: _2_paralipomenon_19,
    20: _2_paralipomenon_20,
    21: _2_paralipomenon_21,
    22: _2_paralipomenon_22,
    23: _2_paralipomenon_23,
    24: _2_paralipomenon_24,
    25: _2_paralipomenon_25,
    26: _2_paralipomenon_26,
    27: _2_paralipomenon_27,
    28: _2_paralipomenon_28,
    29: _2_paralipomenon_29,
    30: _2_paralipomenon_30,
    31: _2_paralipomenon_31,
    32: _2_paralipomenon_32,
    33: _2_paralipomenon_33,
    34: _2_paralipomenon_34,
    35: _2_paralipomenon_35,
    36: _2_paralipomenon_36,
  },
  "2-peter": {
    1: _2_peter_1,
    2: _2_peter_2,
    3: _2_peter_3,
  },
  "2-thessalonians": {
    1: _2_thessalonians_1,
    2: _2_thessalonians_2,
    3: _2_thessalonians_3,
  },
  "2-timothy": {
    1: _2_timothy_1,
    2: _2_timothy_2,
    3: _2_timothy_3,
    4: _2_timothy_4,
  },
  "3-john": {
    1: _3_john_1,
  },
  "3-kings": {
    1: _3_kings_1,
    2: _3_kings_2,
    3: _3_kings_3,
    4: _3_kings_4,
    5: _3_kings_5,
    6: _3_kings_6,
    7: _3_kings_7,
    8: _3_kings_8,
    9: _3_kings_9,
    10: _3_kings_10,
    11: _3_kings_11,
    12: _3_kings_12,
    13: _3_kings_13,
    14: _3_kings_14,
    15: _3_kings_15,
    16: _3_kings_16,
    17: _3_kings_17,
    18: _3_kings_18,
    19: _3_kings_19,
    20: _3_kings_20,
    21: _3_kings_21,
    22: _3_kings_22,
  },
  "4-kings": {
    1: _4_kings_1,
    2: _4_kings_2,
    3: _4_kings_3,
    4: _4_kings_4,
    5: _4_kings_5,
    6: _4_kings_6,
    7: _4_kings_7,
    8: _4_kings_8,
    9: _4_kings_9,
    10: _4_kings_10,
    11: _4_kings_11,
    12: _4_kings_12,
    13: _4_kings_13,
    14: _4_kings_14,
    15: _4_kings_15,
    16: _4_kings_16,
    17: _4_kings_17,
    18: _4_kings_18,
    19: _4_kings_19,
    20: _4_kings_20,
    21: _4_kings_21,
    22: _4_kings_22,
    23: _4_kings_23,
    24: _4_kings_24,
    25: _4_kings_25,
  },
  "abdias": {
    1: abdias_1,
  },
  "acts-of-the-apostles": {
    1: acts_of_the_apostles_1,
    2: acts_of_the_apostles_2,
    3: acts_of_the_apostles_3,
    4: acts_of_the_apostles_4,
    5: acts_of_the_apostles_5,
    6: acts_of_the_apostles_6,
    7: acts_of_the_apostles_7,
    8: acts_of_the_apostles_8,
    9: acts_of_the_apostles_9,
    10: acts_of_the_apostles_10,
    11: acts_of_the_apostles_11,
    12: acts_of_the_apostles_12,
    13: acts_of_the_apostles_13,
    14: acts_of_the_apostles_14,
    15: acts_of_the_apostles_15,
    16: acts_of_the_apostles_16,
    17: acts_of_the_apostles_17,
    18: acts_of_the_apostles_18,
    19: acts_of_the_apostles_19,
    20: acts_of_the_apostles_20,
    21: acts_of_the_apostles_21,
    22: acts_of_the_apostles_22,
    23: acts_of_the_apostles_23,
    24: acts_of_the_apostles_24,
    25: acts_of_the_apostles_25,
    26: acts_of_the_apostles_26,
    27: acts_of_the_apostles_27,
    28: acts_of_the_apostles_28,
  },
  "aggeus": {
    1: aggeus_1,
    2: aggeus_2,
  },
  "amos": {
    1: amos_1,
    2: amos_2,
    3: amos_3,
    4: amos_4,
    5: amos_5,
    6: amos_6,
    7: amos_7,
    8: amos_8,
    9: amos_9,
  },
  "apocalypse": {
    1: apocalypse_1,
    2: apocalypse_2,
    3: apocalypse_3,
    4: apocalypse_4,
    5: apocalypse_5,
    6: apocalypse_6,
    7: apocalypse_7,
    8: apocalypse_8,
    9: apocalypse_9,
    10: apocalypse_10,
    11: apocalypse_11,
    12: apocalypse_12,
    13: apocalypse_13,
    14: apocalypse_14,
    15: apocalypse_15,
    16: apocalypse_16,
    17: apocalypse_17,
    18: apocalypse_18,
    19: apocalypse_19,
    20: apocalypse_20,
    21: apocalypse_21,
    22: apocalypse_22,
  },
  "baruch": {
    1: baruch_1,
    2: baruch_2,
    3: baruch_3,
    4: baruch_4,
    5: baruch_5,
    6: baruch_6,
  },
  "canticle-of-canticles": {
    1: canticle_of_canticles_1,
    2: canticle_of_canticles_2,
    3: canticle_of_canticles_3,
    4: canticle_of_canticles_4,
    5: canticle_of_canticles_5,
    6: canticle_of_canticles_6,
    7: canticle_of_canticles_7,
    8: canticle_of_canticles_8,
  },
  "colossians": {
    1: colossians_1,
    2: colossians_2,
    3: colossians_3,
    4: colossians_4,
  },
  "daniel": {
    1: daniel_1,
    2: daniel_2,
    3: daniel_3,
    4: daniel_4,
    5: daniel_5,
    6: daniel_6,
    7: daniel_7,
    8: daniel_8,
    9: daniel_9,
    10: daniel_10,
    11: daniel_11,
    12: daniel_12,
    13: daniel_13,
    14: daniel_14,
  },
  "deuteronomy": {
    1: deuteronomy_1,
    2: deuteronomy_2,
    3: deuteronomy_3,
    4: deuteronomy_4,
    5: deuteronomy_5,
    6: deuteronomy_6,
    7: deuteronomy_7,
    8: deuteronomy_8,
    9: deuteronomy_9,
    10: deuteronomy_10,
    11: deuteronomy_11,
    12: deuteronomy_12,
    13: deuteronomy_13,
    14: deuteronomy_14,
    15: deuteronomy_15,
    16: deuteronomy_16,
    17: deuteronomy_17,
    18: deuteronomy_18,
    19: deuteronomy_19,
    20: deuteronomy_20,
    21: deuteronomy_21,
    22: deuteronomy_22,
    23: deuteronomy_23,
    24: deuteronomy_24,
    25: deuteronomy_25,
    26: deuteronomy_26,
    27: deuteronomy_27,
    28: deuteronomy_28,
    29: deuteronomy_29,
    30: deuteronomy_30,
    31: deuteronomy_31,
    32: deuteronomy_32,
    33: deuteronomy_33,
    34: deuteronomy_34,
  },
  "ecclesiastes": {
    1: ecclesiastes_1,
    2: ecclesiastes_2,
    3: ecclesiastes_3,
    4: ecclesiastes_4,
    5: ecclesiastes_5,
    6: ecclesiastes_6,
    7: ecclesiastes_7,
    8: ecclesiastes_8,
    9: ecclesiastes_9,
    10: ecclesiastes_10,
    11: ecclesiastes_11,
    12: ecclesiastes_12,
  },
  "ecclesiasticus": {
    1: ecclesiasticus_1,
    2: ecclesiasticus_2,
    3: ecclesiasticus_3,
    4: ecclesiasticus_4,
    5: ecclesiasticus_5,
    6: ecclesiasticus_6,
    7: ecclesiasticus_7,
    8: ecclesiasticus_8,
    9: ecclesiasticus_9,
    10: ecclesiasticus_10,
    11: ecclesiasticus_11,
    12: ecclesiasticus_12,
    13: ecclesiasticus_13,
    14: ecclesiasticus_14,
    15: ecclesiasticus_15,
    16: ecclesiasticus_16,
    17: ecclesiasticus_17,
    18: ecclesiasticus_18,
    19: ecclesiasticus_19,
    20: ecclesiasticus_20,
    21: ecclesiasticus_21,
    22: ecclesiasticus_22,
    23: ecclesiasticus_23,
    24: ecclesiasticus_24,
    25: ecclesiasticus_25,
    26: ecclesiasticus_26,
    27: ecclesiasticus_27,
    28: ecclesiasticus_28,
    29: ecclesiasticus_29,
    30: ecclesiasticus_30,
    31: ecclesiasticus_31,
    32: ecclesiasticus_32,
    33: ecclesiasticus_33,
    34: ecclesiasticus_34,
    35: ecclesiasticus_35,
    36: ecclesiasticus_36,
    37: ecclesiasticus_37,
    38: ecclesiasticus_38,
    39: ecclesiasticus_39,
    40: ecclesiasticus_40,
    41: ecclesiasticus_41,
    42: ecclesiasticus_42,
    43: ecclesiasticus_43,
    44: ecclesiasticus_44,
    45: ecclesiasticus_45,
    46: ecclesiasticus_46,
    47: ecclesiasticus_47,
    48: ecclesiasticus_48,
    49: ecclesiasticus_49,
    50: ecclesiasticus_50,
    51: ecclesiasticus_51,
  },
  "ephesians": {
    1: ephesians_1,
    2: ephesians_2,
    3: ephesians_3,
    4: ephesians_4,
    5: ephesians_5,
    6: ephesians_6,
  },
  "esther": {
    1: esther_1,
    2: esther_2,
    3: esther_3,
    4: esther_4,
    5: esther_5,
    6: esther_6,
    7: esther_7,
    8: esther_8,
    9: esther_9,
    10: esther_10,
    11: esther_11,
    12: esther_12,
    13: esther_13,
    14: esther_14,
    15: esther_15,
    16: esther_16,
  },
  "exodus": {
    1: exodus_1,
    2: exodus_2,
    3: exodus_3,
    4: exodus_4,
    5: exodus_5,
    6: exodus_6,
    7: exodus_7,
    8: exodus_8,
    9: exodus_9,
    10: exodus_10,
    11: exodus_11,
    12: exodus_12,
    13: exodus_13,
    14: exodus_14,
    15: exodus_15,
    16: exodus_16,
    17: exodus_17,
    18: exodus_18,
    19: exodus_19,
    20: exodus_20,
    21: exodus_21,
    22: exodus_22,
    23: exodus_23,
    24: exodus_24,
    25: exodus_25,
    26: exodus_26,
    27: exodus_27,
    28: exodus_28,
    29: exodus_29,
    30: exodus_30,
    31: exodus_31,
    32: exodus_32,
    33: exodus_33,
    34: exodus_34,
    35: exodus_35,
    36: exodus_36,
    37: exodus_37,
    38: exodus_38,
    39: exodus_39,
    40: exodus_40,
  },
  "ezechiel": {
    1: ezechiel_1,
    2: ezechiel_2,
    3: ezechiel_3,
    4: ezechiel_4,
    5: ezechiel_5,
    6: ezechiel_6,
    7: ezechiel_7,
    8: ezechiel_8,
    9: ezechiel_9,
    10: ezechiel_10,
    11: ezechiel_11,
    12: ezechiel_12,
    13: ezechiel_13,
    14: ezechiel_14,
    15: ezechiel_15,
    16: ezechiel_16,
    17: ezechiel_17,
    18: ezechiel_18,
    19: ezechiel_19,
    20: ezechiel_20,
    21: ezechiel_21,
    22: ezechiel_22,
    23: ezechiel_23,
    24: ezechiel_24,
    25: ezechiel_25,
    26: ezechiel_26,
    27: ezechiel_27,
    28: ezechiel_28,
    29: ezechiel_29,
    30: ezechiel_30,
    31: ezechiel_31,
    32: ezechiel_32,
    33: ezechiel_33,
    34: ezechiel_34,
    35: ezechiel_35,
    36: ezechiel_36,
    37: ezechiel_37,
    38: ezechiel_38,
    39: ezechiel_39,
    40: ezechiel_40,
    41: ezechiel_41,
    42: ezechiel_42,
    43: ezechiel_43,
    44: ezechiel_44,
    45: ezechiel_45,
    46: ezechiel_46,
    47: ezechiel_47,
    48: ezechiel_48,
  },
  "galatians": {
    1: galatians_1,
    2: galatians_2,
    3: galatians_3,
    4: galatians_4,
    5: galatians_5,
    6: galatians_6,
  },
  "genesis": {
    1: genesis_1,
    2: genesis_2,
    3: genesis_3,
    4: genesis_4,
    5: genesis_5,
    6: genesis_6,
    7: genesis_7,
    8: genesis_8,
    9: genesis_9,
    10: genesis_10,
    11: genesis_11,
    12: genesis_12,
    13: genesis_13,
    14: genesis_14,
    15: genesis_15,
    16: genesis_16,
    17: genesis_17,
    18: genesis_18,
    19: genesis_19,
    20: genesis_20,
    21: genesis_21,
    22: genesis_22,
    23: genesis_23,
    24: genesis_24,
    25: genesis_25,
    26: genesis_26,
    27: genesis_27,
    28: genesis_28,
    29: genesis_29,
    30: genesis_30,
    31: genesis_31,
    32: genesis_32,
    33: genesis_33,
    34: genesis_34,
    35: genesis_35,
    36: genesis_36,
    37: genesis_37,
    38: genesis_38,
    39: genesis_39,
    40: genesis_40,
    41: genesis_41,
    42: genesis_42,
    43: genesis_43,
    44: genesis_44,
    45: genesis_45,
    46: genesis_46,
    47: genesis_47,
    48: genesis_48,
    49: genesis_49,
    50: genesis_50,
  },
  "habacuc": {
    1: habacuc_1,
    2: habacuc_2,
    3: habacuc_3,
  },
  "hebrews": {
    1: hebrews_1,
    2: hebrews_2,
    3: hebrews_3,
    4: hebrews_4,
    5: hebrews_5,
    6: hebrews_6,
    7: hebrews_7,
    8: hebrews_8,
    9: hebrews_9,
    10: hebrews_10,
    11: hebrews_11,
    12: hebrews_12,
    13: hebrews_13,
  },
  "isaias": {
    1: isaias_1,
    2: isaias_2,
    3: isaias_3,
    4: isaias_4,
    5: isaias_5,
    6: isaias_6,
    7: isaias_7,
    8: isaias_8,
    9: isaias_9,
    10: isaias_10,
    11: isaias_11,
    12: isaias_12,
    13: isaias_13,
    14: isaias_14,
    15: isaias_15,
    16: isaias_16,
    17: isaias_17,
    18: isaias_18,
    19: isaias_19,
    20: isaias_20,
    21: isaias_21,
    22: isaias_22,
    23: isaias_23,
    24: isaias_24,
    25: isaias_25,
    26: isaias_26,
    27: isaias_27,
    28: isaias_28,
    29: isaias_29,
    30: isaias_30,
    31: isaias_31,
    32: isaias_32,
    33: isaias_33,
    34: isaias_34,
    35: isaias_35,
    36: isaias_36,
    37: isaias_37,
    38: isaias_38,
    39: isaias_39,
    40: isaias_40,
    41: isaias_41,
    42: isaias_42,
    43: isaias_43,
    44: isaias_44,
    45: isaias_45,
    46: isaias_46,
    47: isaias_47,
    48: isaias_48,
    49: isaias_49,
    50: isaias_50,
    51: isaias_51,
    52: isaias_52,
    53: isaias_53,
    54: isaias_54,
    55: isaias_55,
    56: isaias_56,
    57: isaias_57,
    58: isaias_58,
    59: isaias_59,
    60: isaias_60,
    61: isaias_61,
    62: isaias_62,
    63: isaias_63,
    64: isaias_64,
    65: isaias_65,
    66: isaias_66,
  },
  "james": {
    1: james_1,
    2: james_2,
    3: james_3,
    4: james_4,
    5: james_5,
  },
  "jeremias": {
    1: jeremias_1,
    2: jeremias_2,
    3: jeremias_3,
    4: jeremias_4,
    5: jeremias_5,
    6: jeremias_6,
    7: jeremias_7,
    8: jeremias_8,
    9: jeremias_9,
    10: jeremias_10,
    11: jeremias_11,
    12: jeremias_12,
    13: jeremias_13,
    14: jeremias_14,
    15: jeremias_15,
    16: jeremias_16,
    17: jeremias_17,
    18: jeremias_18,
    19: jeremias_19,
    20: jeremias_20,
    21: jeremias_21,
    22: jeremias_22,
    23: jeremias_23,
    24: jeremias_24,
    25: jeremias_25,
    26: jeremias_26,
    27: jeremias_27,
    28: jeremias_28,
    29: jeremias_29,
    30: jeremias_30,
    31: jeremias_31,
    32: jeremias_32,
    33: jeremias_33,
    34: jeremias_34,
    35: jeremias_35,
    36: jeremias_36,
    37: jeremias_37,
    38: jeremias_38,
    39: jeremias_39,
    40: jeremias_40,
    41: jeremias_41,
    42: jeremias_42,
    43: jeremias_43,
    44: jeremias_44,
    45: jeremias_45,
    46: jeremias_46,
    47: jeremias_47,
    48: jeremias_48,
    49: jeremias_49,
    50: jeremias_50,
    51: jeremias_51,
    52: jeremias_52,
  },
  "job": {
    1: job_1,
    2: job_2,
    3: job_3,
    4: job_4,
    5: job_5,
    6: job_6,
    7: job_7,
    8: job_8,
    9: job_9,
    10: job_10,
    11: job_11,
    12: job_12,
    13: job_13,
    14: job_14,
    15: job_15,
    16: job_16,
    17: job_17,
    18: job_18,
    19: job_19,
    20: job_20,
    21: job_21,
    22: job_22,
    23: job_23,
    24: job_24,
    25: job_25,
    26: job_26,
    27: job_27,
    28: job_28,
    29: job_29,
    30: job_30,
    31: job_31,
    32: job_32,
    33: job_33,
    34: job_34,
    35: job_35,
    36: job_36,
    37: job_37,
    38: job_38,
    39: job_39,
    40: job_40,
    41: job_41,
    42: job_42,
  },
  "joel": {
    1: joel_1,
    2: joel_2,
    3: joel_3,
  },
  "john": {
    1: john_1,
    2: john_2,
    3: john_3,
    4: john_4,
    5: john_5,
    6: john_6,
    7: john_7,
    8: john_8,
    9: john_9,
    10: john_10,
    11: john_11,
    12: john_12,
    13: john_13,
    14: john_14,
    15: john_15,
    16: john_16,
    17: john_17,
    18: john_18,
    19: john_19,
    20: john_20,
    21: john_21,
  },
  "jonas": {
    1: jonas_1,
    2: jonas_2,
    3: jonas_3,
    4: jonas_4,
  },
  "josue": {
    1: josue_1,
    2: josue_2,
    3: josue_3,
    4: josue_4,
    5: josue_5,
    6: josue_6,
    7: josue_7,
    8: josue_8,
    9: josue_9,
    10: josue_10,
    11: josue_11,
    12: josue_12,
    13: josue_13,
    14: josue_14,
    15: josue_15,
    16: josue_16,
    17: josue_17,
    18: josue_18,
    19: josue_19,
    20: josue_20,
    21: josue_21,
    22: josue_22,
    23: josue_23,
    24: josue_24,
  },
  "jude": {
    1: jude_1,
  },
  "judges": {
    1: judges_1,
    2: judges_2,
    3: judges_3,
    4: judges_4,
    5: judges_5,
    6: judges_6,
    7: judges_7,
    8: judges_8,
    9: judges_9,
    10: judges_10,
    11: judges_11,
    12: judges_12,
    13: judges_13,
    14: judges_14,
    15: judges_15,
    16: judges_16,
    17: judges_17,
    18: judges_18,
    19: judges_19,
    20: judges_20,
    21: judges_21,
  },
  "judith": {
    1: judith_1,
    2: judith_2,
    3: judith_3,
    4: judith_4,
    5: judith_5,
    6: judith_6,
    7: judith_7,
    8: judith_8,
    9: judith_9,
    10: judith_10,
    11: judith_11,
    12: judith_12,
    13: judith_13,
    14: judith_14,
    15: judith_15,
    16: judith_16,
  },
  "lamentations": {
    1: lamentations_1,
    2: lamentations_2,
    3: lamentations_3,
    4: lamentations_4,
    5: lamentations_5,
  },
  "leviticus": {
    1: leviticus_1,
    2: leviticus_2,
    3: leviticus_3,
    4: leviticus_4,
    5: leviticus_5,
    6: leviticus_6,
    7: leviticus_7,
    8: leviticus_8,
    9: leviticus_9,
    10: leviticus_10,
    11: leviticus_11,
    12: leviticus_12,
    13: leviticus_13,
    14: leviticus_14,
    15: leviticus_15,
    16: leviticus_16,
    17: leviticus_17,
    18: leviticus_18,
    19: leviticus_19,
    20: leviticus_20,
    21: leviticus_21,
    22: leviticus_22,
    23: leviticus_23,
    24: leviticus_24,
    25: leviticus_25,
    26: leviticus_26,
    27: leviticus_27,
  },
  "luke": {
    1: luke_1,
    2: luke_2,
    3: luke_3,
    4: luke_4,
    5: luke_5,
    6: luke_6,
    7: luke_7,
    8: luke_8,
    9: luke_9,
    10: luke_10,
    11: luke_11,
    12: luke_12,
    13: luke_13,
    14: luke_14,
    15: luke_15,
    16: luke_16,
    17: luke_17,
    18: luke_18,
    19: luke_19,
    20: luke_20,
    21: luke_21,
    22: luke_22,
    23: luke_23,
    24: luke_24,
  },
  "malachias": {
    1: malachias_1,
    2: malachias_2,
    3: malachias_3,
    4: malachias_4,
  },
  "mark": {
    1: mark_1,
    2: mark_2,
    3: mark_3,
    4: mark_4,
    5: mark_5,
    6: mark_6,
    7: mark_7,
    8: mark_8,
    9: mark_9,
    10: mark_10,
    11: mark_11,
    12: mark_12,
    13: mark_13,
    14: mark_14,
    15: mark_15,
    16: mark_16,
  },
  "matthew": {
    1: matthew_1,
    2: matthew_2,
    3: matthew_3,
    4: matthew_4,
    5: matthew_5,
    6: matthew_6,
    7: matthew_7,
    8: matthew_8,
    9: matthew_9,
    10: matthew_10,
    11: matthew_11,
    12: matthew_12,
    13: matthew_13,
    14: matthew_14,
    15: matthew_15,
    16: matthew_16,
    17: matthew_17,
    18: matthew_18,
    19: matthew_19,
    20: matthew_20,
    21: matthew_21,
    22: matthew_22,
    23: matthew_23,
    24: matthew_24,
    25: matthew_25,
    26: matthew_26,
    27: matthew_27,
    28: matthew_28,
  },
  "micheas": {
    1: micheas_1,
    2: micheas_2,
    3: micheas_3,
    4: micheas_4,
    5: micheas_5,
    6: micheas_6,
    7: micheas_7,
  },
  "nahum": {
    1: nahum_1,
    2: nahum_2,
    3: nahum_3,
  },
  "numbers": {
    1: numbers_1,
    2: numbers_2,
    3: numbers_3,
    4: numbers_4,
    5: numbers_5,
    6: numbers_6,
    7: numbers_7,
    8: numbers_8,
    9: numbers_9,
    10: numbers_10,
    11: numbers_11,
    12: numbers_12,
    13: numbers_13,
    14: numbers_14,
    15: numbers_15,
    16: numbers_16,
    17: numbers_17,
    18: numbers_18,
    19: numbers_19,
    20: numbers_20,
    21: numbers_21,
    22: numbers_22,
    23: numbers_23,
    24: numbers_24,
    25: numbers_25,
    26: numbers_26,
    27: numbers_27,
    28: numbers_28,
    29: numbers_29,
    30: numbers_30,
    31: numbers_31,
    32: numbers_32,
    33: numbers_33,
    34: numbers_34,
    35: numbers_35,
    36: numbers_36,
  },
  "osee": {
    1: osee_1,
    2: osee_2,
    3: osee_3,
    4: osee_4,
    5: osee_5,
    6: osee_6,
    7: osee_7,
    8: osee_8,
    9: osee_9,
    10: osee_10,
    11: osee_11,
    12: osee_12,
    13: osee_13,
    14: osee_14,
  },
  "philemon": {
    1: philemon_1,
  },
  "philippians": {
    1: philippians_1,
    2: philippians_2,
    3: philippians_3,
    4: philippians_4,
  },
  "proverbs": {
    1: proverbs_1,
    2: proverbs_2,
    3: proverbs_3,
    4: proverbs_4,
    5: proverbs_5,
    6: proverbs_6,
    7: proverbs_7,
    8: proverbs_8,
    9: proverbs_9,
    10: proverbs_10,
    11: proverbs_11,
    12: proverbs_12,
    13: proverbs_13,
    14: proverbs_14,
    15: proverbs_15,
    16: proverbs_16,
    17: proverbs_17,
    18: proverbs_18,
    19: proverbs_19,
    20: proverbs_20,
    21: proverbs_21,
    22: proverbs_22,
    23: proverbs_23,
    24: proverbs_24,
    25: proverbs_25,
    26: proverbs_26,
    27: proverbs_27,
    28: proverbs_28,
    29: proverbs_29,
    30: proverbs_30,
    31: proverbs_31,
  },
  "psalms": {
    1: psalms_1,
    2: psalms_2,
    3: psalms_3,
    4: psalms_4,
    5: psalms_5,
    6: psalms_6,
    7: psalms_7,
    8: psalms_8,
    9: psalms_9,
    10: psalms_10,
    11: psalms_11,
    12: psalms_12,
    13: psalms_13,
    14: psalms_14,
    15: psalms_15,
    16: psalms_16,
    17: psalms_17,
    18: psalms_18,
    19: psalms_19,
    20: psalms_20,
    21: psalms_21,
    22: psalms_22,
    23: psalms_23,
    24: psalms_24,
    25: psalms_25,
    26: psalms_26,
    27: psalms_27,
    28: psalms_28,
    29: psalms_29,
    30: psalms_30,
    31: psalms_31,
    32: psalms_32,
    33: psalms_33,
    34: psalms_34,
    35: psalms_35,
    36: psalms_36,
    37: psalms_37,
    38: psalms_38,
    39: psalms_39,
    40: psalms_40,
    41: psalms_41,
    42: psalms_42,
    43: psalms_43,
    44: psalms_44,
    45: psalms_45,
    46: psalms_46,
    47: psalms_47,
    48: psalms_48,
    49: psalms_49,
    50: psalms_50,
    51: psalms_51,
    52: psalms_52,
    53: psalms_53,
    54: psalms_54,
    55: psalms_55,
    56: psalms_56,
    57: psalms_57,
    58: psalms_58,
    59: psalms_59,
    60: psalms_60,
    61: psalms_61,
    62: psalms_62,
    63: psalms_63,
    64: psalms_64,
    65: psalms_65,
    66: psalms_66,
    67: psalms_67,
    68: psalms_68,
    69: psalms_69,
    70: psalms_70,
    71: psalms_71,
    72: psalms_72,
    73: psalms_73,
    74: psalms_74,
    75: psalms_75,
    76: psalms_76,
    77: psalms_77,
    78: psalms_78,
    79: psalms_79,
    80: psalms_80,
    81: psalms_81,
    82: psalms_82,
    83: psalms_83,
    84: psalms_84,
    85: psalms_85,
    86: psalms_86,
    87: psalms_87,
    88: psalms_88,
    89: psalms_89,
    90: psalms_90,
    91: psalms_91,
    92: psalms_92,
    93: psalms_93,
    94: psalms_94,
    95: psalms_95,
    96: psalms_96,
    97: psalms_97,
    98: psalms_98,
    99: psalms_99,
    100: psalms_100,
    101: psalms_101,
    102: psalms_102,
    103: psalms_103,
    104: psalms_104,
    105: psalms_105,
    106: psalms_106,
    107: psalms_107,
    108: psalms_108,
    109: psalms_109,
    110: psalms_110,
    111: psalms_111,
    112: psalms_112,
    113: psalms_113,
    114: psalms_114,
    115: psalms_115,
    116: psalms_116,
    117: psalms_117,
    118: psalms_118,
    119: psalms_119,
    120: psalms_120,
    121: psalms_121,
    122: psalms_122,
    123: psalms_123,
    124: psalms_124,
    125: psalms_125,
    126: psalms_126,
    127: psalms_127,
    128: psalms_128,
    129: psalms_129,
    130: psalms_130,
    131: psalms_131,
    132: psalms_132,
    133: psalms_133,
    134: psalms_134,
    135: psalms_135,
    136: psalms_136,
    137: psalms_137,
    138: psalms_138,
    139: psalms_139,
    140: psalms_140,
    141: psalms_141,
    142: psalms_142,
    143: psalms_143,
    144: psalms_144,
    145: psalms_145,
    146: psalms_146,
    147: psalms_147,
    148: psalms_148,
    149: psalms_149,
    150: psalms_150,
  },
  "romans": {
    1: romans_1,
    2: romans_2,
    3: romans_3,
    4: romans_4,
    5: romans_5,
    6: romans_6,
    7: romans_7,
    8: romans_8,
    9: romans_9,
    10: romans_10,
    11: romans_11,
    12: romans_12,
    13: romans_13,
    14: romans_14,
    15: romans_15,
    16: romans_16,
  },
  "ruth": {
    1: ruth_1,
    2: ruth_2,
    3: ruth_3,
    4: ruth_4,
  },
  "sophonias": {
    1: sophonias_1,
    2: sophonias_2,
    3: sophonias_3,
  },
  "titus": {
    1: titus_1,
    2: titus_2,
    3: titus_3,
  },
  "tobias": {
    1: tobias_1,
    2: tobias_2,
    3: tobias_3,
    4: tobias_4,
    5: tobias_5,
    6: tobias_6,
    7: tobias_7,
    8: tobias_8,
    9: tobias_9,
    10: tobias_10,
    11: tobias_11,
    12: tobias_12,
    13: tobias_13,
    14: tobias_14,
  },
  "wisdom": {
    1: wisdom_1,
    2: wisdom_2,
    3: wisdom_3,
    4: wisdom_4,
    5: wisdom_5,
    6: wisdom_6,
    7: wisdom_7,
    8: wisdom_8,
    9: wisdom_9,
    10: wisdom_10,
    11: wisdom_11,
    12: wisdom_12,
    13: wisdom_13,
    14: wisdom_14,
    15: wisdom_15,
    16: wisdom_16,
    17: wisdom_17,
    18: wisdom_18,
    19: wisdom_19,
  },
  "zacharias": {
    1: zacharias_1,
    2: zacharias_2,
    3: zacharias_3,
    4: zacharias_4,
    5: zacharias_5,
    6: zacharias_6,
    7: zacharias_7,
    8: zacharias_8,
    9: zacharias_9,
    10: zacharias_10,
    11: zacharias_11,
    12: zacharias_12,
    13: zacharias_13,
    14: zacharias_14,
  },
};

export function getChapter(bookSlug, chapterNumber) {
  const n = parseInt(chapterNumber, 10);
  if (!bookSlug || !n) return null;
  return CHAPTERS[bookSlug]?.[n] || null;
}

export function hasChapter(bookSlug, chapterNumber) {
  return getChapter(bookSlug, chapterNumber) !== null;
}

export function getPopulatedChapters(bookSlug) {
  const m = CHAPTERS[bookSlug];
  if (!m) return [];
  return Object.keys(m).map((k) => parseInt(k, 10)).sort((a, b) => a - b);
}

export function getPopulatedBookSlugs() {
  return Object.keys(CHAPTERS);
}
